export function getAngleFromCenter(
  center: { lat: number; lng: number },
  point: { lat: number; lng: number }
): number {
  const latDiff = point.lat - center.lat;
  const lngDiff = point.lng - center.lng;

  let angle = Math.atan2(lngDiff, latDiff) * (180 / Math.PI);

  angle = angle - 0;

  angle = (angle + 360) % 360;

  return angle;
}

export function getAngleFromCenterXY(
  center: { x: number; y: number },
  point: { x: number; y: number }
): number {
  const xDiff = point.x - center.x;
  // Negative because browser Y coordinates increase downward
  const yDiff = -(point.y - center.y);

  // Calculate angle in degrees, using atan2 with x and y swapped for compass orientation
  let angle = Math.atan2(xDiff, yDiff) * (180 / Math.PI);

  // Normalize angle to be between 0 and 360 degrees
  angle = (angle + 360) % 360;

  return angle;
}
export default getAngleFromCenter;
